import { __awaiter } from "tslib";
import { derived, writable } from 'svelte/store';
import { getLanguageData } from './glosbe-dictionary-api/get-language-data';
import { getUserLocale } from './i18n.service';
let languagesCache = writable(new Map());
function makeCacheKey(code, locale) {
    const localeToUse = locale || getUserLocale();
    return `${localeToUse}:${code}`;
}
export function createDummyLanguage(code, name) {
    return {
        code, name: `${name || code}`, dummy: true
    };
}
export function addLanguagesToCache(languages) {
    languagesCache.update(currentCache => {
        const newCache = new Map(currentCache);
        languages.forEach(language => {
            newCache.set(makeCacheKey(language.code, language.appLocale), language);
        });
        return newCache;
    });
}
function fetchLanguageAndAddToCache(code) {
    return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
        try {
            const language = yield getLanguageData(code);
            const appLocale = getUserLocale();
            addLanguagesToCache([Object.assign(Object.assign({}, language), { appLocale: appLocale })]);
            resolve(language);
        }
        catch (error) {
            reject(error);
        }
    }));
}
const fetchingCache = new Map();
function createLanguagesGetterReturningImmediately(cache) {
    return (code, doFetch = false) => {
        const key = makeCacheKey(code);
        if (cache.has(key)) {
            return cache.get(key);
        }
        const fetchingKey = key + "___fetching";
        if (doFetch && !fetchingCache.has(fetchingKey)) {
            fetchingCache.set(fetchingKey, true);
            fetchLanguageAndAddToCache(code);
        }
        return createDummyLanguage(code);
    };
}
function createLanguagesGetterReturningPromise(cached) {
    return (code) => {
        const key = makeCacheKey(code);
        if (cached.has(key)) {
            return Promise.resolve(cached.get(key));
        }
        else {
            return fetchLanguageAndAddToCache(code);
        }
    };
}
/**
 * returns language from cache or dummy created from code
 */
export const getLanguageImmediately = derived(languagesCache, createLanguagesGetterReturningImmediately);
export const getLanguage = derived(languagesCache, createLanguagesGetterReturningPromise);
/**
 * returns Promise that will resolve to language
 */
// export const getLanguage = writable<(code: string) => LanguageDataCarrierV2>(initLanguages(languagesCache));
